module.exports = __webpack_public_path__ + "static/img/shiyongxinxingzhuanli.d577b9b5.jpg";